<template>
    <div>
        test
        <input @input="searchResult($event.target.value)"/>
        <ul>
            <li v-for="(symbol,i) in symbols" :key="i">{{ symbol }}</li>
        </ul>
    </div>
</template>

<script>
import {exampleList} from '@/api/getSymbols';
import { searchFilter } from '@/utils/searchFilter';
    export default {
        name:"testComponent",
        data(){
            return {
                // keyWord:'',
                symbols:[...exampleList['tickers']],
                symbolsOriginal:[...exampleList['tickers']]
            }
        },
        methods:{
            searchResult(keyword){
                // // console.log(keyword);
                let newArray = searchFilter(this.symbolsOriginal,keyword)
                // console.log(newArray);
                this.symbols = [...newArray]
            }
        }
    }
</script>